// extracted by mini-css-extract-plugin
export var avatar = "recipe-author-module--avatar--wGgFE";
export var black = "recipe-author-module--black--zrYbI";
export var dot = "recipe-author-module--dot--suHya";
export var wrapper = "recipe-author-module--wrapper--nNxhv";